import * as React from 'react';

const TutorialArrow = () => (
	<svg className="m-tutorial__arrow" width="18px" height="55px" viewBox="0 0 18 55">
		<g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" strokeLinecap="round">
			<g transform="translate(-152.000000, -114.000000)" stroke="#ffffff" strokeWidth="2.4">
				<g transform="translate(160.197427, 140.265993) rotate(-199.000000) translate(-160.197427, -140.265993) translate(144.697427, 116.765993)">
					<path
						d="M1,41 L8,46"
						strokeLinejoin="round"
						transform="translate(4.500000, 43.500000) rotate(10.000000) translate(-4.500000, -43.500000) "
					/>
					<path
						d="M8,41 L15,46"
						strokeLinejoin="round"
						transform="translate(11.500000, 43.500000) scale(-1, 1) rotate(10.000000) translate(-11.500000, -43.500000) "
					/>
					<path d="M30.0332524,0.178119699 C15.9621066,10.1541848 8,25.7746033 8,44" />
				</g>
			</g>
		</g>
	</svg>
);

TutorialArrow.displayName = 'TutorialArrow';

export { TutorialArrow };

export default TutorialArrow;
